import axios from "axios";
import baseURL from "../config";

class ApiService {
  static request(url, method, payload) {
    const token = (axios.defaults.headers.common["Authorization"] =
      localStorage.getItem("token"));
    if (token) {
      axios.defaults.headers.common["Authorization"] = "Bearer " + token;
    }
    return axios[method](baseURL + url, payload)
      .then((response) => {
        // A 204 carries no body at all, so none of the envelope checks below
        // can see it as success — every DELETE in the CMS screens answers this
        // way, and used to surface as "Unknown error" for a delete that worked.
        if (response.status === 204) {
          return undefined;
        }
        if (
          response.data.result ||
          response.data.status === "success" ||
          response.data.status === "succeeded"
        ) {
          return response.data.data;
        } else if (response.statusText.toLowerCase() === "ok") {
          return response.data;
        } else {
          throw response.data.error;
        }
      })
      .catch((error) => {
        throw error;
      });
  }
}

/**
 * The message an API error carries, whatever shape it arrives in.
 *
 * A property of how `ApiService` rejects, not of any one screen — it had been
 * written out identically in three of them before it lived here.
 */
export const errorMessage = (error) =>
  error?.response?.data?.message || error?.message || "Неизвестна грешка";

export default ApiService;
